import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "../../return-to-checkout-modal.module.css";
import { ModalState } from "../../return-to-checkout-modal.types";
import { VehicleInformation } from "../../vehicle-information/vehicle-information.component";
import { Primary, Secondary } from "@cinch-labs/design-system";
import React, { useEffect } from "react";
export var ReturnToCheckoutOrderActive = function(param) {
    var vehicle = param.vehicle, onButtonClick = param.onButtonClick, onSecondaryButtonClick = param.onSecondaryButtonClick, isButtonLoading = param.isButtonLoading, isSecondaryButtonLoading = param.isSecondaryButtonLoading, i18n = param.i18n, adminFeeFlag = param.adminFeeFlag, adminFeeValueInPence = param.adminFeeValueInPence, trackEvent = param.trackEvent, noOpTracking = param.noOpTracking, onModalOpen = param.onModalOpen;
    useEffect(function() {
        onModalOpen(ModalState.active);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentWrapper,
        children: [
            i18n.title,
            /*#__PURE__*/ _jsx(VehicleInformation, {
                vehicle: vehicle,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent
            }),
            /*#__PURE__*/ _jsx(Primary, {
                isLoading: isButtonLoading,
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                classNames: {
                    button: styles.button
                },
                isLoading: isSecondaryButtonLoading,
                disabled: isSecondaryButtonLoading,
                onClick: onSecondaryButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.secondaryButtonText
            })
        ]
    });
};
